class DigiLaunch {
  constructor(section) {
    this.section = section;
    this.tabs = [...section.querySelectorAll('[data-launch-tab]')];
    this.panels = [...section.querySelectorAll('[data-launch-panel]')];
    this.copyButton = section.querySelector('[data-copy-coupon]');
    this.addButtons = [...section.querySelectorAll('[data-launch-add]')];
    this.timer = null;

    this.tabs.forEach((tab) => tab.addEventListener('click', () => {
      this.select(tab.dataset.launchTab);
      this.restartAutoplay();
    }));

    this.copyButton?.addEventListener('click', () => this.copyCoupon());
    this.addButtons.forEach((button) => {
      button.addEventListener('click', () => this.addToCart(button));
    });
    this.startAutoplay();
  }

  select(value) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.launchTab === value;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.launchPanel === value;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  startAutoplay() {
    if (
      this.tabs.length < 2 ||
      this.panels.length < 2 ||
      this.section.dataset.autoplay !== 'true' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) return;
    const interval = Number(this.section.dataset.interval) || 5000;
    this.timer = window.setInterval(() => {
      const current = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
      const next = this.tabs[(current + 1) % this.tabs.length];
      this.select(next.dataset.launchTab);
    }, interval);
  }

  restartAutoplay() {
    window.clearInterval(this.timer);
    this.startAutoplay();
  }

  async addToCart(button) {
    let variantId = Number(button.dataset.variantId);
    const productHandle = button.dataset.productHandle;
    const defaultLabel = button.dataset.defaultLabel || 'EU QUERO';

    if (button.disabled) return;

    button.disabled = true;
    button.textContent = 'ADICIONANDO...';

    try {
      if (!variantId && productHandle) {
        const productResponse = await fetch(`/products/${encodeURIComponent(productHandle)}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (!productResponse.ok) throw new Error('Produto não encontrado.');

        const product = await productResponse.json();
        const availableVariant = product.variants?.find((variant) => variant.available);
        variantId = Number(availableVariant?.id);
      }

      if (!variantId) throw new Error('Nenhuma variante disponível.');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Não foi possível adicionar o produto.');
      }

      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const cart = cartResponse.ok ? await cartResponse.json() : null;

      // Sincroniza o carrinho com os mesmos pontos de integração do tema.
      if (cart) {
        if (typeof window.updateCart === 'function') window.updateCart(cart);
        document.querySelectorAll('.cart-count-bubble, [data-cart-count], .header__cart-count, .digi-cart-count').forEach((counter) => {
          counter.textContent = cart.item_count;
          counter.classList.toggle('is-empty', cart.item_count === 0);
        });
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true, detail: { cart, source: 'digi-launch' },
      }));
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart, source: 'digi-launch' },
      }));
      document.dispatchEvent(new CustomEvent('cart:change', {
        detail: { cart, source: 'digi-launch' },
      }));

      // O drawer Halo é aberto pelo acionador real do cabeçalho.
      const cartToggle = document.querySelector('[data-open-cart-sidebar]') ||
        document.querySelector('[data-cart-toggle]');
      if (cartToggle) {
        cartToggle.click();
      } else {
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        document.dispatchEvent(new CustomEvent('drawer:open'));
      }

      button.textContent = 'ADICIONADO!';

      window.setTimeout(() => {
        button.textContent = defaultLabel;
        button.disabled = false;
      }, 1800);
    } catch (error) {
      console.error('[Digi Launch] Erro ao adicionar produto:', error);
      button.textContent = 'TENTE NOVAMENTE';

      window.setTimeout(() => {
        button.textContent = defaultLabel;
        button.disabled = false;
      }, 2200);
    }
  }

  async copyCoupon() {
    const label = this.copyButton.querySelector('[data-copy-label]');
    try {
      await navigator.clipboard.writeText(this.copyButton.dataset.copyCoupon);
      label.textContent = 'Copiado!';
      window.setTimeout(() => { label.textContent = 'Copiar'; }, 1800);
    } catch (error) {
      label.textContent = 'Selecione o código';
    }
  }
}

const initDigiLaunch = (scope = document) => {
  scope.querySelectorAll('[data-digi-launch]').forEach((section) => {
    if (!section.dataset.initialized) {
      section.dataset.initialized = 'true';
      new DigiLaunch(section);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initDigiLaunch());
document.addEventListener('shopify:section:load', (event) => initDigiLaunch(event.target));
